<template>
    <k-panel class="border">
        <k-panel-header slot="header">{{ $t("additionalDocuments") }}</k-panel-header>
        <div class="text-sm">
            {{ $t("additionalDocumentsDesc") }}

            <div class="mt-6">
                <vue-dropzone
                    style="padding: 10px;"
                    :options="dropzoneOptions"
                    @vdropzone-success="fileUploaded"
                    @vdropzone-removed-file="fileRemoved"
                    :useCustomSlot=true
                    id="additionalFile"
                    ref="additionalFile"
                >
                    <div>
                        <div class="font-bold text-primary-500">{{ $t("additionalDocuments") }}</div>
                        <div class="mt-3 text-sm text-gray-500">{{ $t("dragAndDrop") }}</div>
                    </div>
                </vue-dropzone>
                <div v-if="fieldError('fileReference')"
                     class="text-red-500 text-xs italic">
                    {{ fieldError('fileReference') }}
                </div>
            </div>
        </div>
        <div slot="footer" class="mt-3">
            <a-button type="primary" @click.native.prevent="uploadDocument" :disabled="uploadDisabled">{{ $t("upload") }}</a-button>
        </div>
    </k-panel>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    components: {
        vueDropzone: vue2Dropzone
    },
    props: {
        documentSaveUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            fileReferences: [],
            dropzoneOptions: {
                url: '/api/guest/upload',
                thumbnailWidth: null,
                thumbnailHeight: 200,
                maxFiles: 5,
                maxFilesize: 25,
                addRemoveLinks: true,
                createImageThumbnails: true,
                init: function () {
                    this.on('addedfile', function () {
                        if (this.files.length > 5) {
                            this.removeFile(this.files[0]);
                        }
                    });
                }
            },
            validation: {
                fieldErrors: {}
            }
        }
    },
    computed: {
        uploadDisabled() {
            return this.fileReferences.length === 0;
        }
    },
    methods: {
        async uploadDocument() {
            this.validation = {
                fieldErrors: {}
            };
            try {
                await this.$post(this.documentSaveUrl, {fileReferences: this.fileReferences});
                this.removeAllFiles();
                this.$message.success(this.$i18n.t('documentUploaded'));
            } catch (error) {
                console.error(error)
                if (error.response && error.response.status === 400) {
                    this.validation = error.response.data;
                }
            }
        },
        fileUploaded(file, response) {
            this.fileReferences.push(response.fileReference);
            file.fileReference = response.fileReference;
        },
        fileRemoved(file) {
            let index = this.fileReferences.indexOf(file.fileReference)
            if (index !== -1) {
                this.fileReferences.splice(index, 1)
            }
        },
        removeAllFiles() {
            this.$refs.additionalFile.removeAllFiles();
            this.fileReferences = [];
        },
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
    }
}
</script>


